module.exports = __webpack_public_path__ + "img/LOGO ARTY SYSTEM22.bf7367ae.png";